import {
    Button,
    Divider,
    Grid,
    Stack,
    ThemeProvider,
    Typography,
    useMediaQuery,
    useTheme,
} from '@mui/material';
import React, { useState } from 'react';
import IndividualExperienceSpacesModal, {
    sortSpacesByType,
} from './IndividualExperienceSpacesModal';
import SpaceCard from './SpaceCard';
import { BeddingCustomTheme } from './Spaces/BeddingCustomBreakpoints';
import { getBeddingArray, ModifiedSpace } from './Spaces/IndividualSpace';

const IndividualExperienceSpaces = ({
    spaces,
}: {
    spaces: ModifiedSpace[];
}) => {
    const theme = useTheme();
    const [showModal, setShowModal] = useState(false);

    const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
    const isIpad = useMediaQuery(theme.breakpoints.down('md'));

    const numberOfBedsArray = spaces.map((space) => getBeddingArray(space));

    const totalBedsPerSpace = numberOfBedsArray.map((space) =>
        space.reduce((total, [_, count]) => total + count, 0),
    );

    const maxNumberOfBeds = Math.max(...totalBedsPerSpace);

    const visibleSpaces = sortSpacesByType(spaces).slice(0, 3);

    return (
        <Grid
            sx={{
                height: 'auto',
                paddingTop: isIpad ? '10px' : '30px',
                width: isMobile || isIpad ? '100%' : '88%',
            }}
        >
            <Divider
                sx={{
                    width: '100%',
                    color: theme.palette.faded.main,
                }}
            />
            <Grid>
                <Grid
                    sx={{
                        paddingTop: '20px',
                    }}
                >
                    {' '}
                    <Typography variant='h2'>Space Configurations</Typography>
                </Grid>

                <ThemeProvider theme={BeddingCustomTheme}>
                    <Stack
                        sx={{
                            display: 'flex',
                            flexDirection: 'column',
                            alignItems: 'flex-end',
                            gap: 4,
                            paddingTop: '20px',
                        }}
                    >
                        <Grid container spacing={4}>
                            {visibleSpaces.map((space, index) => (
                                <Grid key={index} item xs={12} md={6}>
                                    <SpaceCard
                                        space={space}
                                        selected={false}
                                        spaces={spaces}
                                        maxNumberOfBeds={maxNumberOfBeds}
                                        cursor={
                                            spaces.length > 3
                                                ? 'pointer'
                                                : 'default'
                                        }
                                    />
                                </Grid>
                            ))}
                        </Grid>
                        {spaces.length > visibleSpaces.length && (
                            <Button
                                color='primary'
                                onClick={() => setShowModal(true)}
                                style={{
                                    marginLeft: '8px',
                                    textTransform: 'none',
                                    fontFamily: theme.typography.fontFamily,
                                    fontSize: '.75rem',
                                }}
                            >
                                Show all {spaces.length} spaces
                            </Button>
                        )}
                    </Stack>
                    <IndividualExperienceSpacesModal
                        open={showModal}
                        onClose={() => setShowModal(false)}
                        spaces={spaces}
                        maxNumberOfBeds={maxNumberOfBeds}
                    />
                </ThemeProvider>
            </Grid>
        </Grid>
    );
};

export default IndividualExperienceSpaces;
